import { render } from "./ChannelAvatar.vue?vue&type=template&id=1a29954a&scoped=true"
import script from "./ChannelAvatar.vue?vue&type=script&lang=js"
export * from "./ChannelAvatar.vue?vue&type=script&lang=js"

import "./ChannelAvatar.vue?vue&type=style&index=0&id=1a29954a&scoped=true&lang=css"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a29954a"]])

export default __exports__